import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const USER_HCP_VERIFICATION_FLAG_KEY = 'release-user-hcp-verification';

/**
 * FE rollout gate for clinician (NPI) verification of existing US users: the
 * account-settings card and the verification modal. Defaults OFF; a build with
 * no provider, or a user outside the Flagsmith cohort, sees nothing and issues
 * no verification request.
 *
 * The backend gate on `/hcp-verifications` is the source of truth for
 * eligibility (deployment, country, flag). This flag only decides whether the
 * client asks. Rollout/kill gate, not an experiment — do not add
 * `useManualExposure`.
 */
export const useIsUserHcpVerificationEnabled = (): boolean =>
  useBooleanFlagValue(USER_HCP_VERIFICATION_FLAG_KEY, false);
